import { useRef, useState } from "react";
import { ImagePlus, Loader2, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errMsg, imgUrl } from "@/lib/api";
import { toast } from "sonner";

export async function uploadImage(file) {
  const fd = new FormData();
  fd.append("file", file);
  return (await api.post("/uploads", fd)).data.url;
}

export function ImageUpload({ value, onChange }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) return toast.error("A imagem deve ter no máximo 5 MB");
    setBusy(true);
    try {
      onChange(await uploadImage(file));
      toast.success("Foto enviada");
    } catch (err) {
      toast.error(errMsg(err, "Não foi possível enviar a foto"));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="flex items-center gap-3" data-testid="image-upload">
      <div className="h-20 w-20 shrink-0 overflow-hidden rounded-lg border bg-muted grid place-items-center">
        {value ? <img src={imgUrl(value)} alt="Foto do produto" className="h-full w-full object-cover" data-testid="image-upload-preview" /> : <ImagePlus className="h-6 w-6 text-muted-foreground/60" />}
      </div>
      <div className="flex flex-col gap-2">
        <Button type="button" size="sm" variant="outline" disabled={busy} onClick={() => ref.current?.click()} data-testid="image-upload-btn">
          {busy ? <Loader2 className="h-4 w-4 mr-1 animate-spin" /> : <ImagePlus className="h-4 w-4 mr-1" />}{value ? "Trocar foto" : "Enviar foto"}
        </Button>
        {value && <Button type="button" size="sm" variant="ghost" onClick={() => onChange("")} data-testid="image-remove-btn"><X className="h-4 w-4 mr-1" />Remover</Button>}
      </div>
      <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp,image/gif,application/pdf" className="hidden" onChange={pick} data-testid="image-upload-input" />
    </div>
  );
}
